import * as actions from '../actions/SavedSearchesActions';

const initialState = { pageTitle: null };

function SavedSearchesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_SAVED_SEARCHES_BY_ENTITY: {
      const { payload } = action;
      const oldValue = state?.[payload.entityName] || {};

      const value = {
        ...oldValue,
        fetching: true,
        error: null,
      };

      return {
        ...state,
        [payload.entityName]: value,
      };
    }

    case actions.GET_SAVED_SEARCHES_BY_ENTITY_SUCCESS: {
      const { payload } = action;
      const oldValue = state?.[payload.entityName] || {};
      const value = {
        ...oldValue,
        searches: payload.searches,
        groups: payload.groups,
        fetching: false,
        error: null,
      };

      return {
        ...state,
        [payload.entityName]: value,
      };
    }

    case actions.GET_SAVED_SEARCHES_BY_ENTITY_FAILURE: {
      const { payload } = action;
      const oldValue = state?.[payload.entityName] ?? {};
      const value = {
        ...oldValue,
        error: payload.error,
        fetching: false,
      };

      return {
        ...state,
        [payload.entityName]: value,
      };
    }

    case actions.SAVED_SEARCHES_PAGE_TITLE: {
      return { ...state, pageTitle: action.pageTitle };
    }

    case actions.FORCE_SAVED_SEARCH_REFRESH: {
      const { entityName, flag } = action.payload;

      const oldValue = state?.[entityName] ?? {};
      const value = {
        ...oldValue,
        shouldRefresh: flag,
      };

      return {
        ...state,
        [entityName]: value,
      };
    }

    default:
      return state;
  }
}

export default SavedSearchesReducer;
